import { getAccountImpTransactions, getAccountTransactionSummary, getAccountTransactions } from "../types/account_transactions_types";

const initState = {
    transactions: {
        data: [],
        count: 0,
        loading: false
    },
    impTransactions: {
        data: [],
        count: 0,
        loading: false
    },
    summary: {
        data: [],
        count: 0,
        loading: false
    }
};

export default function getAccountTransactionsReducers(state = initState, action = {}) {
    switch (action.type) {
        case getAccountTransactions.GET_ACCOUNT_TRANSACTIONS_REQUEST:
            return {
                ...state,
                transactions: {
                    ...state.transactions,
                    loading: true
                }

            };
        case getAccountTransactions.GET_ACCOUNT_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                transactions: {
                    ...state.transactions,
                    loading: false,
                    data: action.payload.data,
                    count: action.payload.count,
                }
            };
        case getAccountTransactions.GET_ACCOUNT_TRANSACTIONS_ERROR:
            return {
                ...state,
                transactions: {
                    ...state.transactions,
                    loading: false
                }
            };
        case getAccountImpTransactions.GET_ACCOUNT_IMP_TRANSACTIONS_REQUEST:
            return {
                ...state,
                impTransactions: {
                    ...state.impTransactions,
                    loading: true
                }

            };
        case getAccountImpTransactions.GET_ACCOUNT_IMP_TRANSACTIONS_SUCCESS:
            return {
                ...state,
                impTransactions: {
                    ...state.impTransactions,
                    loading: false,
                    data: action.payload.data,
                    count: action.payload.count,
                }
            };
        case getAccountImpTransactions.GET_ACCOUNT_IMP_TRANSACTIONS_ERROR:
            return {
                ...state,
                impTransactions: {
                    ...state.impTransactions,
                    loading: false
                }
            };
        case getAccountTransactionSummary.GET_ACCOUNT_TRANSACTIONS_SUMMARY_REQUEST:
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: true
                }

            };
        case getAccountTransactionSummary.GET_ACCOUNT_TRANSACTIONS_SUMMARY_SUCCESS:
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: false,
                    data: action.payload.data,
                    count: action.payload.count,
                }
            };
        case getAccountTransactionSummary.GET_ACCOUNT_TRANSACTIONS_SUMMARY_ERROR:
            return {
                ...state,
                summary: {
                    ...state.summary,
                    loading: false
                }
            };

        default:
            return state;
    }
}
